const initialState = {
    get: null,
};

const informationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_INFORMATION_SUCCESS':
            return {
                ...state,
                get: action.payload,
            };
        case 'GET_INFORMATION_FAILURE':
            return state;
        default:
            return state;
    }
};

export default informationReducer;
